import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Sidebar from "./sidebar";
import Header from "./header";
import { Link } from "react-router-dom";

const Layout = ({ children }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleUserDropdown = () => {
    setUserDropdownOpen(!userDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setUserDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      navigate("/login");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const user = JSON.parse(sessionStorage.getItem("users"))?.userdatils || {};
  const userName = user?.name || "User";
  const userRole = user?.role || "Admin";

  const businessName =
    JSON.parse(sessionStorage.getItem("users"))?.userdatils?.business_name ||
    "Default Name";

  // Get initials from name
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar - responsive sliding and toggling props */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black opacity-50 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      {/* Main content area — offset by sidebar width (17rem) on medium screens */}
      <div className="flex flex-col flex-1 min-h-0 md:ml-[17rem]">
        {/* Header */}
        <div className="hidden md:block"><Header /></div>

        {/* Mobile header */}
        <header className="bg-white shadow-sm z-40 md:hidden">
          <div className="flex items-center justify-between p-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="flex items-center gap-2 px-4 py-3 rounded-md bg-white shadow-md hover:shadow-lg transition duration-200 font-semibold text-gray-800"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            {/* User Dropdown */}
            <Link
              to="/profile"
              className="flex items-center gap-3 hover:bg-[#635BFF] rounded-full pl-1 pr-3 py-1 transition-all duration-200 group"
            >
              <div className="relative">
                <div className="w-9 h-9 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-medium group-hover:bg-white group-hover:text-[#635BFF] transition-colors">
                  {getInitials(businessName)}
                </div>
                <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white group-hover:border-[#635BFF]"></div>
              </div>
              <div className="hidden md:block">
                <p className="text-sm font-medium text-gray-900 group-hover:text-white leading-tight transition-colors">
                  {businessName}
                </p>
              </div>
            </Link>
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto md:p-4 bg-gray-50 relative">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
